import React, { lazy } from 'react'
import { Switch } from 'react-router-dom'
import PrivateRoute from '../../components/PrivateRoute'
import PreceptorPage from './PreceptorPage'
import PreceptorForm from './PreceptorForm'

export default () => (
    <Switch>
        <PrivateRoute exact path="/preceptores" component={PreceptorPage} />
        <PrivateRoute
            exact
            path="/preceptores/:id/edit"
            component={PreceptorForm}
        />
        <PrivateRoute exact path="/preceptores/new" component={PreceptorForm} />
    </Switch>
)
